import { bindToSelection } from 'yourchoice-redux'

const SELECTION_NAME = 'mySelection'
export default bindToSelection(SELECTION_NAME)



// WEBPACK FOOTER //
// ./src/bound-selection.js